import Sunny from "../assets/svg/sunny.svg";
import darkmode from "../assets/png/icons8-do-not-disturb-ios-20.png";
import clsx from "clsx";
import { useTheme } from "../helpers/core/action";

const SwitchMode = () => {
  const { storedTheme, toggleTheme } = useTheme();

  return (
    <div>
      <label
        className={clsx("switch-toggle rounded-pill m-0", {
          checked: storedTheme === "dark",
        })}
        onClick={toggleTheme}
        style={{ cursor: "pointer" }}
      >
        <span className="slider rounded-circle d-flex justify-content-center align-items-center">
          <img
            src={storedTheme === "dark" ? Sunny : darkmode}
            alt={storedTheme === "dark" ? "Dark Mode" : "Light Mode"}
          />
        </span>
      </label>
    </div>
  );
};

export default SwitchMode;
